import imgVehicleLuxury from '../assets/img/vehicles/luxury-car.svg?inline';
import imgVehicleMedium from '../assets/img/vehicles/medium-car.svg?inline';
import imgVehicleMini from '../assets/img/vehicles/mini.svg?inline';
import imgVehicleOther from '../assets/img/vehicles/other.svg?inline';
import imgVehicleSmall from '../assets/img/vehicles/small-car.svg?inline';
import imgVehicleSport from '../assets/img/vehicles/sports-car.svg?inline';
import imgVehicleSUV from '../assets/img/vehicles/suv.svg?inline';
import imgVehicleVan from '../assets/img/vehicles/van.svg?inline';

var data = {
    links: {
        companies: {
            oblik: 'http://oblik.works/',
            betapeak: 'https://betapeak.com/'
        }
    },
    vehicles: {
        mini: {
            title: 'Mini',
            image: imgVehicleMini,
            examples: ['Smart Fortwo', 'Fiat Panda', 'Citroën C1']
        },
        small: {
            title: 'Small',
            image: imgVehicleSmall,
            examples: ['VW Polo', 'Mini Cooper', 'Fiat Punto', 'BMW i3']
        },
        medium: {
            title: 'Medium',
            image: imgVehicleMedium,
            examples: ['VW Golf', 'Audi A3', 'Volvo C30', 'Chevrolet Bolt EV']
        },
        luxury: {
            title: 'Luxury',
            image: imgVehicleLuxury,
            examples: ['VW Passat', 'Audi A4', 'BMW 3 Series', 'Tesla Model S']
        },
        sport: {
            title: 'Sport',
            image: imgVehicleSport,
            examples: ['BMW Z4', 'Porsche 911', 'Mercedes-Benz SLK', 'Honda S2000']
        },
        van: {
            title: 'Van',
            image: imgVehicleVan,
            examples: ['Mercedes-Benz Viano', 'Ford S-MAX', 'VW Sharan']
        },
        suv: {
            title: 'SUV',
            image: imgVehicleSUV,
            examples: ['Mitsubishi L200', 'Nissan Navara', 'VW Amarok']
        },
        other: {
            title: 'Other',
            image: imgVehicleOther,
            examples: ['VW Transporter-T5', 'Opel Vivaro', 'Mercedes-Benz Vito']
        }
    },
    fuels: {
        petrol: {
            title: 'Petrol',
            icon: ['fal', 'tint'],
            emissionsText: 'A petrol car generates approximately 33.2 tonnes of CO<sub>2</sub> for its lifetime.'
        },
        diesel: {
            title: 'Diesel',
            icon: ['fal', 'tint'],
            emissionsText: 'A diesel car generates approximately 34.8 tonnes of CO<sub>2</sub> for its lifetime.'
        },
        lpg: {
            title: 'LPG',
            icon: ['fal', 'tint'],
            emissionsText: 'LPG emits significantly less CO<sub>2</sub> and NO<sub>X</sub> than petrol and diesel fuel.'
        },
        hybrid: {
            title: 'Hybrid',
            icon: ['fal', 'hybrid-fuel'],
            emissionsText: 'A hybrid vehicle\'s emissions depend on both its fuel consumption and the electricity it uses.'
        },
        electric: {
            title: 'Electric',
            icon: ['fal', 'battery-bolt'],
            emissionsText: 'This is based on average emissions generated by electricity sources.'
        }
    },
    alternatives: {
        WALKING: {
            title: 'Walking',
            icon: ['far', 'walking'],
            description: 'Walking. It\'s the most carbon-friendly form of transportation after cycling.'
        },
        BICYCLING: {
            title: 'Bicycling',
            icon: ['far', 'bicycle'],
            description: 'Cycling is the greenest way of transport.'
        },
        TRANSIT: {
            title: 'Transit',
            icon: ['fas', 'exchange-alt'],
            description: 'Public transport can be up to 70% greener than a car. It depends on how the local government produces energy.'
        },
        BUS: {
            title: 'Bus',
            icon: ['fas', 'bus-alt'],
            description: 'Public transportation reduces overall greenhouse gas emissions and emits less NO<sub>X</sub>.'
        },
        COACH: {
            title: 'Coach',
            icon: ['fas', 'bus'],
            description: 'Public transportation reduces overall greenhouse gas emissions and emits less NO<sub>X</sub>.'
        },
        SUBWAY: {
            title: 'Subway',
            icon: ['fas', 'subway'],
            description: 'Rail transport is one of the greenest ways of traveling.'
        },
        TRAIN: {
            title: 'Train',
            icon: ['fas', 'train'],
            description: 'Rail transport is one of the greenest ways of traveling.'
        },
        TRAM: {
            title: 'Tram',
            icon: ['fas', 'train'],
            description: 'Rail transport is one of the greenest ways of traveling.'
        },
        PLANE: {
            title: 'Plane',
            icon: ['fas', 'plane-alt'],
            description: null // in AlternativeTransport component
        },
        ELECTRIC: {
            title: 'Electric Vehicles',
            icon: ['fas', 'battery-bolt'],
            description: 'How clean electric vehicles are depends on the way the electricity has been generated.'
        }
    },
    facts: [
        {
            title: 'Pollution Effects',
            icon: ['fas', 'cloud'],
            entries: [
                {
                    type: 'fact',
                    title: 'Greenhouse Effect',
                    text: `A major threat from increased CO<sub>2</sub> is the greenhouse effect. As a greenhouse gas, excesses of it create a cover that traps the sun's heat energy in the atmospheric bubble, warming the planet and the oceans. An increase of CO<sub>2</sub> alters the Earth's climate by causing changes in weather patterns. This raises the temperature of the ocean water, compromising its ability to absorb carbon dioxide.`
                },
                {
                    type: 'fact',
                    title: 'Climate Change',
                    text: `An environmental effect of air pollution is climate change. The earth's surface temperature has risen over the course of the last 100 years, according to studies done by the National Oceanic and Atmospheric Administration (NOAA). Scientists believe CO<sub>2</sub> pollution is the primary culprit. Evidence shows that ocean water levels have increased, resulting in a loss of shoreline and coastal wetlands.`
                },
                {
                    type: 'fact',
                    title: 'Acid Rain',
                    text: `CO<sub>2</sub> is a contributor to the environmental effect known as acid rain. Emissions from the burning of fossil fuels combine with the moisture in the air, resulting in precipitation with a high acid content. Documented evidence show that this leads to physical damage to trees and other plant life, water and soil pollution and more.`
                },
                {
                    type: 'fact',
                    title: 'Human Health Impacts',
                    text: `CO<sub>2</sub> emissions impact human health by displacing oxygen in the atmosphere. Breathing becomes more difficult as carbon dioxide levels rise and in closed areas, high levels of it can lead to health complaints, such as headaches. High CO<sub>2</sub> levels may indicate high levels of other harmful air pollutants like volatile organic compounds, which contribute to indoor air pollution.`
                },
                {
                    type: 'fact',
                    text: `A tree can absorb as much as 21.7 kilograms / 48 pounds of carbon dioxide per year and can sequester 1 tonne of carbon dioxide by the time it reaches 40 years. There are approximately 3 trillion trees on the planet.`
                },
                {
                    type: 'fact',
                    text: `At the moment, there are approximately 400 trees for every person on earth, decreasing by 1.4 each year.`
                }
            ]
        },
        {
            title: 'Overall Transport',
            icon: ['fas', 'suitcase'],
            entries: [
                {
                    type: 'fact',
                    text: `Transport accounts for around a quarter of UK’s carbon emissions, a key contributor to climate change.`
                },
                {
                    type: 'fact',
                    text: `Traveling by train is the cleanest travel option.`
                },
                {
                    type: 'fact',
                    text: `Approximately 24% of all CO<sub>2</sub> emissions are generated by transport. In comparison, the industry sector is responsible for 19%.`
                },
                {
                    type: 'fact',
                    text: `Road transportation is responsible for almost ⅔ of all emissions in the transport sector around the world.`
                },
                {
                    type: 'fact',
                    text: `Statistics for 2014 show that in Europe, 44.4% of all emissions from the transport sector were generated by cars. The share of electric transport emissions from that total was only 0.5%.`
                },
                {
                    type: 'fact',
                    text: `Almost 60% of all road vehicles are passenger cars.`
                },
                {
                    type: 'fact',
                    text: `A 2011 study shows that the Chinese transport sector was responsible for 628 million tonnes of CO<sub>2</sub> emissions, a figure almost four times higher than that of Germany. Current research by the study partner TPRI suggests that in 2014, the road transport and mobile machinery sectors could have been responsible for a total of 989 million tonnes of CO<sub>2</sub> emissions.`
                },
                {
                    type: 'fact',
                    text: `According to the U.S. Department of Transportation Federal Highway Administration, the average American drives 13,476 miles. That's more than four times the distance from New York City to Los Angeles, California. Data has been updated in 2018.`
                },
                {
                    type: 'fact',
                    text: `According to the Federal Highway Administration, in 2016, drivers in cars, trucks, minivans, and SUVs put a record 3.22 trillion miles on the nation's roads, which is up by 2.8% compared to 2015 when the number was 3.1 trillion miles.`
                },
                {
                    type: 'fact',
                    text: `In Australia, transport is the 3rd largest source of emissions and in 2014, it was also the highest growing in the country. On average, 85% of those emissions are generated by road transport.`
                },
                {
                    type: 'fact',
                    text: `In 2017, fossil fuels were the largest sources of energy for electricity generation in the USA.`
                },
                {
                    type: 'fact',
                    text: `Natural gas was the largest source—about 32%—of U.S. electricity generation in 2017. It's used in steam turbines and gas turbines to generate electricity.`
                },
                {
                    type: 'fact',
                    text: `Coal was the second largest energy source for U.S. electricity generation in 2017—about 30%. Nearly all coal-fired power plants use steam turbines and a few of those plants convert coal to gas for use in gas turbines to generate electricity.`
                }
            ]
        },
        {
            title: 'Public Transport',
            icon: ['fas', 'bus-alt'],
            entries: [
                {
                    type: 'fact',
                    text: `Public transport can be up to 70% cleaner and 90% safer than a car.`
                },
                {
                    type: 'fact',
                    text: `Commuting to work by subway emits 73% less CO<sub>2</sub> than commuting by car.`
                },
                {
                    type: 'fact',
                    text: `According to the American Public Transportation Association, communities that invest in public transit reduce the nation's carbon emissions levels significantly. Public transportation's overall effects save the United States 4.2 billion gallons of gasoline annually.`
                },
                {
                    type: 'fact',
                    text: `A person can reduce their chance of being in an accident by more than 90% simply by taking public transit as opposed to commuting by car.`
                }
            ]
        },
        {
            title: 'Cars',
            icon: ['fas', 'car'],
            entries: [
                {
                    type: 'fact',
                    text: `The number of new cars sold across the globe in 2017 is 96.8 million, according to <abbr title="Organisation Internationale des Constructeurs d'Automobiles">OICA</abbr>.`
                },
                {
                    type: 'fact',
                    text: `In recent years, cars with alternative fuel in Europe are under 3.5% of all cars in use. The most used fuel is petrol, which is used by 55.6% of all cars, followed by diesel with 41.2%.`
                },
                {
                    type: 'fact',
                    text: `Provisional registrations or sales of new vehicles in 2017: in EU’s 28 countries + <abbr title="European Free Trade Association">EFTA</abbr>–18.1 million units, in the US–17.5 million, in China–29.1 million. The total number worldwide is 96.8 million units.`
                },
                {
                    type: 'fact',
                    text: `In 2015, in only a few countries, the sales of electric vehicles were just over 1% of all cars sold for the year.`
                },
                {
                    type: 'fact',
                    text: `Electric cars have lower GHG emissions per kilometer compared to regular cars. In Iceland, electric car use has almost no impact to climate change.`
                }
            ]
        },
        {
            title: 'Hybrids and Electric Vehicles',
            icon: ['fas', 'bolt'],
            entries: [
                {
                    type: 'fact',
                    text: `Pure electric vehicles don’t produce any greenhouse gas exhaust emissions and those from plug-in hybrids are significantly lower than those from traditional petrol or diesel cars.`
                },
                {
                    type: 'fact',
                    text: `How clean electric and hybrid vehicles are depends on the electricity they use or more specifically – the way it has been generated. Greener electricity means a greener vehicle. Currently, almost 100% of the electricity in Iceland is generated by renewable energy. From Europe, Finland, Norway, and Sweden are also countries leading by percentage of green electricity.`
                },
                {
                    type: 'fact',
                    text: `Another thing to consider when choosing an electric or hybrid vehicle is how much CO<sub>2</sub> emissions are generated by the production a single unit. This aspect is important because the batteries for these types of vehicles generate more CO<sub>2</sub> emissions compared to the production of a fuel-powered engine.`
                }
            ]
        },
        {
            title: 'Aviation',
            icon: ['fas', 'plane-alt'],
            entries: [
                {
                    type: 'fact',
                    text: `The number of all passengers that travelled around the world by air in 2016 was 3.7 billion. The International Air Transport Association expects that number to reach 7.8 billion by 2036.`
                },
                {
                    type: 'fact',
                    text: `In 2016, the aviation sector covered by the EU ETS has increased its emissions levels with 7.6% compared to the previous year. The seven largest aircraft operators were responsible for 44% of these emissions.`
                },
                {
                    type: 'fact',
                    text: `Low-cost flight companies were the highest emissions emitters in the aviation sector in 2016, according to Trends and projections in the EU ETS in 2017 and The EU Emissions Trading System in numbers EEA Report No 18/2017.`
                }
            ]
        },
        {
            title: 'Take Action',
            icon: ['fas', 'fist-raised'],
            entries: [
                {
                    type: 'suggestion',
                    text: `Try to use your car less. Walk or ride your bike when possible. If you have to travel long distances, avoid planes and travel by train.`
                },
                {
                    type: 'suggestion',
                    text: `An average car is parked for 22 hours a day. Shared car programs are becoming more and more popular and you can check what options you have in your area. This is a good way to limit your personal CO<sub>2</sub> emissions.`
                },
                {
                    type: 'suggestion',
                    text: `When buying a car, ask what's the car manufacturer CO<sub>2</sub> policy. Check how much CO<sub>2</sub> is generated for the production of the model that you want and how much emissions are generated while driving.`
                },
                {
                    type: 'suggestion',
                    text: `Check the CO<sub>2</sub> emissions offset programs of the flight companies you use and what they do to reduce their emissions. Some companies have significantly higher emissions levels than others.`
                },
                {
                    type: 'suggestion',
                    text: `High-polluting cars must be banned or limited, ask your local authorities what actions have been taken on the matter.`
                },
                {
                    type: 'suggestion',
                    text: `Inform your friends and family about the environmental impact of traveling.`
                },
                {
                    type: 'suggestion',
                    text: `If you're a driver, switching to an electric vehicle will reduce your carbon footprint, which is essential for protecting the future of our planet.`
                },
                {
                    type: 'suggestion',
                    text: `We recommend you check with your local government how the electricity in your area is generated.`
                }
            ]
        }
    ]
};

export default {
    methods: {
        presets (key) {
            return data[key];
        }
    }
};
